import React, { Component } from 'react';
import {
  withStyles,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid,
  Typography,
  IconButton,
  Button,
  Tooltip,
  Checkbox
} from '@material-ui/core';
import OpenInNew from '@material-ui/icons/OpenInNew';
import styles from './styles/ProblemsTableStyles';
import SortHeaderIcon from '../../commons/components/SortHeaderIcon';
import problemsTypesMap from '../../commons/ProblemsTypesMap';
import ResultList from './ResultList';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    position: 'sticky',
    top: 0,
    whiteSpace: 'nowrap',
    zIndex: 1
  },
  body: {
    backgroundColor: theme.palette.common.white,
    fontSize: 14
  }
}))(TableCell);

class ProblemsTable extends Component {
  state = {
    resultListOpen: false,
    coordinateProblems: [],
    selected: ''
  };

  handleScroll = (event) => {
    if (!this.state.resultListOpen && this.props.coordinatesProblems.length >= 20) {
      const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
      if (bottom) {
        this.props.addCoordinatesProblems();
      }
    }
  }

  handleOpenResultList = (coordinateProblems) => {
    if (!coordinateProblems.result) {
      this.props.getCoordinatesResult(coordinateProblems.serial, coordinateProblems.createdDate);
    }
    this.setState({ resultListOpen: true, coordinateProblems, selected: coordinateProblems.serial + coordinateProblems.createdDate });
  };

  handleCloseResultList = () => {
    this.setState({ resultListOpen: false });
  }

  sortProblems = (column) => {
    let { order } = this.props;
    if (order === 'ASC') order = 'DESC';
    else if (order === 'DESC') order = 'ASC';
    this.props.updateFilterOrder(order, column);
  }

  openVehicleInfoOnTrix = (coordinateProblems) => {
    this.setState({ selected: coordinateProblems.serial + coordinateProblems.createdDate });
    let tomorrowsDate = new Date(coordinateProblems.createdDate);
    tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);
    tomorrowsDate = this.getFormattedDate(tomorrowsDate);
    window.open(
      `https://trix2.trixlog.com/#/vehicle/details/${coordinateProblems.vehicleId}//${coordinateProblems.createdDate}T03:00:00.000Z/${tomorrowsDate}T02:59:59.999Z`,
      '_blank'
    );
  }

  getFormattedDate = (date) => {
    return date.toISOString().substr(0, 10);
  }

  isSelected = coordinateProblems => {
    const isSelected = coordinateProblems.serial + coordinateProblems.createdDate === this.state.selected;
    return isSelected;
  }

  downloadProblems = () => {
    this.props.downloadProblems();
  }

  render() {
    const { classes, coordinatesProblems, order, orderByField } = this.props;
    if (coordinatesProblems && coordinatesProblems.length > 0) {
      return (
        <div>
          <Typography variant="title" className={classes.tableTitle} id="tableTitle">
            Problemas por Equipamento - <a className={classes.problemsDowloadButton} onClick={this.downloadProblems}>Exportar Problemas</a>
          </Typography>
          <Grid className={classes.root} onScroll={this.handleScroll}>
            <Table>
              <TableHead>
                <TableRow>
                  <CustomTableCell />
                  <CustomTableCell />
                  <CustomTableCell />
                  <CustomTableCell className={classes.sortHeader} onClick={() => this.sortProblems('serial')}>
                    Serial <SortHeaderIcon order={order} orderBy={orderByField} column="serial"/>
                  </CustomTableCell>
                  <CustomTableCell className={classes.sortHeader} onClick={() => this.sortProblems('organizationName')}>
                    Organização <SortHeaderIcon order={order} orderBy={orderByField} column="organizationName"/>
                  </CustomTableCell>
                  <CustomTableCell className={classes.sortHeader} onClick={() => this.sortProblems('vehicleCode')}>
                    Código do Veículo <SortHeaderIcon order={order} orderBy={orderByField} column="vehicleCode"/>
                  </CustomTableCell>
                  <CustomTableCell className={classes.sortHeader} onClick={() => this.sortProblems('createdDate')}>
                    Data de Criação <SortHeaderIcon order={order} orderBy={orderByField} column="createdDate"/>
                  </CustomTableCell>
                  {Object.keys(problemsTypesMap).map((problemType, key) =>
                    <CustomTableCell color="primary" key={key}>
                      {problemsTypesMap[problemType]}
                    </CustomTableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {coordinatesProblems.map((coordinateProblems) => {
                  const isSelected = this.isSelected(coordinateProblems);
                  return (
                    <TableRow hover selected={isSelected} key={coordinateProblems.id}>
                      <CustomTableCell>
                        <Checkbox checked={isSelected} disabled/>
                      </CustomTableCell>
                      <CustomTableCell>
                        <Tooltip id="tooltip-top" title="Ver no Trix" placement="top">
                          <div>
                            <IconButton
                              disabled={!coordinateProblems.vehicleId}
                              color="primary"
                              onClick={() => this.openVehicleInfoOnTrix(coordinateProblems)}
                            >
                              <OpenInNew />
                            </IconButton>
                          </div>
                        </Tooltip>
                      </CustomTableCell>
                      <CustomTableCell>
                        <Button color="primary" size="small" onClick={() => this.handleOpenResultList(coordinateProblems)}>Detalhes</Button>
                      </CustomTableCell>
                      <CustomTableCell>{coordinateProblems.serial}</CustomTableCell>
                      <CustomTableCell>{coordinateProblems.organizationName || 'N/A'}</CustomTableCell>
                      <CustomTableCell>{coordinateProblems.vehicleCode || 'N/A'}</CustomTableCell>
                      <CustomTableCell>{coordinateProblems.createdDate.split('-').reverse().join('/')}</CustomTableCell>
                      {Object.keys(problemsTypesMap).map((problemType, key) => {
                        const hasProblem = coordinateProblems.problemsTypes.find(item => item === problemType);
                        const cellClass = hasProblem ? classes.cellError : classes.cellOk;
                        return <CustomTableCell key={key} className={cellClass}> {hasProblem ? 'SIM' : 'NÃO'} </CustomTableCell>;
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
          <ResultList 
            handleClose={this.handleCloseResultList}
            open={this.state.resultListOpen}
            result={this.state.coordinateProblems.result}
          />
        </div>
      );
    }
    
    return null;
  }
}

export default withStyles(styles)(ProblemsTable);


// WEBPACK FOOTER //
// ./src/main/components/ProblemsTable.jsx